import { memo, forwardRef } from "react"
import styled, { css } from "styled-components"

import InputBase from "../InputBase"

export default memo(
  forwardRef(function Input(
    { label, isError, disabled, errorMsg, wrapperStyle, labelStyle, errorStyle, ...rest },
    ref
  ) {
    return (
      <InputBase wrapperStyle={wrapperStyle}>
        {label !== undefined && <InputLabel labelStyle={labelStyle}>{label}</InputLabel>}
        <div>
          <InputStyle ref={ref} isError={isError} disabled={disabled} {...rest} />
          {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
        </div>
      </InputBase>
    )
  })
)

const InputLabel = styled.label`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (13 / 375));

  ${({ labelStyle }) => labelStyle && labelStyle}
`

const InputStyle = styled.input`
  border: 1px solid #d5d5d5;
  color: #121212;
  outline: none;
  padding: calc(100vw * (14 / 375)) calc(100vw * (11 / 375));
  border-radius: calc(100vw * (5 / 375));
  background: #fff;
  width: 100%;
  font-size: calc(100vw * (14 / 375));

  &:focus {
    border: 1px solid #ffcf19;
  }

  &::placeholder {
    color: #c6c6c6;
  }

  ${({ isError }) =>
    isError &&
    css`
      border: 1px solid #de0000;
      &:focus {
        border: 1px solid #de0000;
      }
    `}
`

const ErrorMsg = styled.p`
  padding-top: calc(100vw * (4 / 375));
  color: #de0000;
  font-size: calc(100vw * (12 / 375));
  line-height: calc(100vw * (20 / 375));
  font-weight: 600;
`
